export default __webpack_public_path__ + "static/media/modal-bg.6ec00d81.jpg";